import React, {useEffect, useState} from 'react';

import styled from 'styled-components';
import {
    Contents,
    DropdownMenu,
} from 'view/components';
import {isEmpty, textTransform} from "../../../../util";
import {cloneDeep} from "lodash";
import {coachingAPI} from "../../../../api/coachingAPI";
import CloseGrey from "../../../../assets/images/icon/CloseGrey";

interface StyledComponentProps{
    isOn:boolean
}

const TimeAwayPopup = (props) => {
    const onKeyDown = (e) => {
        if(e.keyCode === 13){
            props?.onClick()
        }
    }
    const [isOn, setIsOn] = useState(false);
    const [coachingData, setCoachingData] = useState(null);
    const [timeAwayData, setTimeAwayData] = useState([]);
    const handleToggle = () => {
        setIsOn(!isOn);
    };

    const getCoaData = async () => {
        await coachingAPI.getProductById(props?.data?.id)
            .then((res) => {
                console.log("res",res)
                setCoachingData(cloneDeep(res?.data))
            })
    }

    const updateTimeAway = async (stateData) => {
        console.log("stateData", stateData)
        let data = {}
        const c = cloneDeep(stateData)
        await c?.forEach(item => {
            data[String(item?.type)?.toLocaleLowerCase()] = item?.timeAway
        })

        const checkArr = Object.values(data)

        if(checkArr?.length === stateData?.length){
            await coachingAPI.updateTimeAway(props?.data?.id,{
                data:{
                    ...data
                }
            })
                .then(res => {
                    props?.getList();
                })
        }
    };

    useEffect(() => {
        if(!isEmpty(coachingData?.coaching?.coachingTypes)){
            const c = cloneDeep(coachingData?.coaching?.coachingTypes)
            const arr = c?.map(item => {
                return {
                    type:item?.contentType,
                    timeAway:item?.timeAway
                }
            })
            setTimeAwayData(cloneDeep(arr));
        }
    }, [coachingData?.coaching?.coachingTypes, props?.data?.id]);

    useEffect(() => {
        getCoaData()
    }, [props?.data?.id]);

    console.log("@timeAwayData",timeAwayData);
    console.log("cTy",props?.data)

    return (
        <Container>
            <Contents title={""}>
                <Inner>
                    <Close
                        onClick={()=>{
                            props?.close();
                        }}
                    >
                        <CloseGrey/>
                    </Close>
                    <h1>Time Away</h1>
                    <div className="textarea">
                        <h2>If you need to take a break or won’t be able to process coaching requests as usual,
                            you can activate the ‘Time Away’ mode. Please note that any pending coaching
                            requests must be completed before activating this mode.</h2>
                        <h4>
                            To temporarily pause sales and activate the ‘Time Away’ mode, simply switch the
                            toggle to the ‘on’ position.
                        </h4>
                    </div>

                    <Wrap
                        style={{height:`calc(56px * ${timeAwayData?.length})`}}
                        // style={{height: `calc(56px * 3)`}}
                    >
                        {
                            !isEmpty(timeAwayData) &&
                            timeAwayData?.map((item, index) => {
                                return (
                                    <SwitchItems>
                                    <span>
                                        {textTransform()?.capitalizeFirstLetter(String(item?.type)?.toLocaleLowerCase())}
                                    </span>
                                        <SwitchContainer>
                                        <SwitchLabel isOn={item?.timeAway}>
                                            <SwitchInput type="checkbox" checked={item?.timeAway} onChange={() => {
                                                const c = cloneDeep(timeAwayData)
                                                c[index].timeAway = !c[index]?.timeAway;
                                                setTimeAwayData(c)
                                                updateTimeAway(c)
                                            }} />
                                            <SwitchSlider isOn={item?.timeAway} />
                                        </SwitchLabel>
                                    </SwitchContainer>
                                </SwitchItems>
                            )
                        })
                    }

                    </Wrap>
                </Inner>
            </Contents>

        </Container>
    );
};
export default TimeAwayPopup;

const Container = styled.div`
    position: relative;
    max-width: 700px;
    @media screen and (max-width: 768px) {
        margin: 0 auto;
        width: 90%;
    }
    h1 {
        color: #333;
        font-family: Europa-Bold;
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: 0.52px;
        margin-bottom: 26px;
    }
`;
const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.35s;
    height: 0;
    width: 100%;
    overflow-y: hidden;
`
const Close = styled.div`
     width: 100%;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    svg{
        pointer-events: none;
    }
`
const Inner = styled.div`
    transition: all 0.35s;
    padding: 20px 26px 11px 26px;
    width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h2, h4{
        color: #333;
        font-family: var(--fontFamilyRegular);
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
        margin-bottom: 0.75rem;
    }
    @media screen and (max-width: 768px) {
        width: 100%;
        .textarea{
            height: 200px;
            overflow-y: scroll;
            margin-bottom: 16px;

            scrollbar-width: thin;
            scroll-behavior: smooth;
            scrollbar-color: #33333320 transparent;
    
            &::-webkit-scrollbar {
                width: 3px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: rgba(51, 51, 51, 0.5);
                border: none;
                border-radius: 5px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
                border: none;
            }
        }
    }
    p {
        font-size: 18px;
        font-weight: 400;
    }
    h2{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
    }
    h4{
        margin-top: 20px;
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
        margin-bottom: 25px;
    }
`;
const SwitchItems = styled.div`
   display: flex;
    width: 212px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    &:nth-last-of-type(1){
        margin-bottom: 0px;
    }
   span{
       font-family: Europa-Bold;
       font-size: 20px;
       font-weight: 700;
       line-height: 24px;
       letter-spacing: 0em;
       text-align: left;
       color: #333;
   }
`
const SwitchContainer = styled.div`
  position: relative;
  width: 45px;
  height: 26px;
    display: flex;
    align-items: center;
`;

const SwitchSlider = styled.div<StyledComponentProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 26px;
  height: 26px;
  border-radius: 15px;
  transition: 0.3s;
  background: #333;      
  transform: translateX(${props => (props.isOn ? '22px' : '0')});
`;

const SwitchLabel = styled.label<StyledComponentProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 45px;
  height: 21px;
  border-radius: 15px;
  cursor: pointer;
    box-shadow: 0px 0px 8px 0px #00000029 inset;

    background-color:${props => (props.isOn ? '#87CEEB' : '#fff')};

`;

const SwitchInput = styled.input`
  display: none;
`;